import React from "react";
import Heading from "../components/Heading";
import { TfiClip } from "react-icons/tfi";
const Tickets = () => {
  return (
    <div className="p-4 px-6 h-screen">
      <div className="mt-6">
        <Heading />
      </div>
      <div className="mt-8 w-full p-8 flex flex-col gap-6 border">
        <div>
          <div className="text-2xl font-bold">
            (Module Name) Inquiry #AP1234
          </div>
          <div className="text-[#777777] text-xl">Created 15 seconds ago</div>
          <div className="text-xl">
            <span className="font-bold"> Status: </span> {/*  */}Open
          </div>
        </div>
        <div className="border-t"></div>
        <div className="text-2xl">Your Message</div>
        <div>
          <div className="w-full border">
            <div className="p-2 px-4 border">Reply to Support</div>
            <div className="w-full">
              <textarea
                placeholder="Type of Message"
                className="p-2 px-4 w-full h-40"
              ></textarea>
            </div>
          </div>
          <div className="h-20 w-full px-4 border flex justify-between items-center">
            <div className="text-[#0D8BFF] flex items-center gap-2 text-xl cursor-pointer">
              <TfiClip />
              <span className=""> Add an Attachment</span>
            </div>
            <div>
              <button className="h-11 w-[158px] rounded bg-[#F8F8F8] text-[#999999]">
                Send
              </button>
            </div>
          </div>
        </div>
        <div className="w-full h-[78px] px-4 border flex items-center">
          Cufront has replied by email.{" "}
          <span className="text-[#0D8BFF] cursor-pointer">
            Redirect to email.
          </span>
        </div>
        <div>
          <div className="w-full border">
            <div className="p-2 px-4 border flex items-center gap-2">
              <div className="h-9 w-9 rounded-full border"></div>
              <div className="text-xl">Rishabh Sahu</div>
            </div>
            <div className="h-30 p-4 w-full border text-[#777777]">
              <div>Description</div>
              <div> Alternate Email </div>
              <div>Email Contact </div>
              <div>Reason</div>
            </div>
          </div>
          <div className="h-20 w-full px-4 border flex justify-between items-center">
            <div className="text-[#0D8BFF] flex items-center gap-2 text-xl cursor-pointer">
              <TfiClip />
              <span className=""> Add an Attachment</span>
            </div>
            <div>
              <button className="h-11 w-[158px] rounded bg-[#F8F8F8] text-[#999999]">
                Send
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Tickets;
